module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new/_next/static/images/marquee_mobile3-bf4ee656036847711feaf93034ce06bc.jpg";